"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Tracker.scss");
var Tracker = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    var stepItems = "";
    // start at index 1, since completedSteps is off 1
    for (var index = 1; index <= data.steps; index++) {
        // completed steps more than or equal to?
        stepItems +=
            data.completedSteps >= index
                ? '<div class="bg-functional-blue"></div>'
                : '<div class="bg-ui-light-gray"></div>';
    }
    return (React.createElement("div", { className: "mar-b-xs", "data-testid": testId },
        options.showHeading && React.createElement("h2", { className: "heading-md mar-b-none" }, options.heading),
        React.createElement("div", { className: "flex flex-items-center mar-t-xs mar-b-xxxs " + styles.tracker, dangerouslySetInnerHTML: { __html: stepItems } }),
        React.createElement("div", { className: "type-sm color-ui-black font-medium" },
            data.label,
            React.createElement("div", { className: "type-sm hidden-spoken" },
                "Step ",
                data.completedSteps,
                " of ",
                data.steps,
                " steps completed"))));
};
exports.default = Tracker;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tracker/Tracker.js
// module id = 1830
// module chunks = 8